import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { offer } from '../data/offer';
export function Close() {
  return <section className="w-full border-y-4 border-shuttle bg-court-deep" data-id="element-51" data-mp="1zvbdssjy911c">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-52" data-mp="1uwrs8t99pr9i">
        <h2 className="font-display font-bold text-white text-[28px] leading-tight tracking-tight sm:text-5xl" data-id="element-53" data-mp="1q01ck71dkxom">
          Stop building from zero.{' '}
          <span className="text-shuttle-soft" data-id="element-54" data-mp="1l1zvtsrf9agb">Walk in ready, and still follow their lead.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-white/90" data-id="element-55" data-mp="1c7uxko9ykwqr">
          Arrive, ground, express, relate, energize, transition and close.
          Written, sequenced, printable, and ready to adapt.
        </p>

        <div className="mt-7" data-id="element-56" data-mp="12a721w4j3l7j">
          <Countdown size="sm" tone="dark" data-id="element-57" data-mp="128cgqgpchr2x" />
        </div>

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-2xl border border-shuttle bg-white/10 px-5 py-4 text-left" data-id="element-58" data-mp="xaugrftb2m72">
          <div data-id="element-59" data-mp="3ve3sd08gtu86">
            <span className="block text-[10px] font-bold uppercase tracking-widest text-shuttle-soft" data-id="element-60" data-mp="3vdkblmujxbvq">
              Complete pack
            </span>
            <span className="text-[15px] font-bold text-white" data-id="element-61" data-mp="3liadha79xon8">
              Movement Group Ready: 6 Volumes + 5 Bonuses
            </span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-62" data-mp="i0in208sdcr5">
            <span className="text-[15px] text-white/65 line-through" data-id="element-63" data-mp="i11w0rggkqt1">${offer.anchor}</span>
            <span className="font-display text-4xl font-bold leading-none text-white" data-id="element-64" data-mp="myagwzszr8xz">
              ${offer.price}
            </span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-65" data-mp="d0wazu4p22jx">
          <CtaButton data-id="element-66" data-mp="czkv4vxz54cg">Yes, get my year of groups: ${offer.price}</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/80" data-id="element-67" data-mp="2sr0custe7fgw">
          {['Secure checkout', 'Instant access', `${offer.guaranteeDays}-day guarantee`].map(item => <li key={item} className="flex items-center gap-2" data-id="element-68" data-mp="148edq0qhcda2">
              <span className="h-1.5 w-1.5 rounded-full bg-shuttle" data-id="element-69" data-mp="z9kvjv08zy3k" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}